import { render, staticRenderFns } from "./InspectionViewAssessmentList.vue?vue&type=template&id=939f626c&scoped=true"
import script from "./InspectionViewAssessmentList.vue?vue&type=script&lang=js"
export * from "./InspectionViewAssessmentList.vue?vue&type=script&lang=js"
import style0 from "./InspectionViewAssessmentList.vue?vue&type=style&index=0&id=939f626c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939f626c",
  null
  
)

export default component.exports